module.exports = __webpack_public_path__ + "static/media/cert.bb5e1a47.png";